import { PhoneIcon } from '@gemini/icons';
import { getPortalUrl } from '@/utils/getPortalUrl';
import { createBrand } from '../factory';
import { Layout } from './Layout';
export default createBrand({
    brand: 'immowelt',
    shortBrand: 'IWT',
    portalUrl: getPortalUrl('iwt'),
    template: Layout,
    pages: {
        fsrbo: {
            generic: {
                realEstateListing: {
                    dashLine: {
                        desktop: 'https://cdnihddipa.cloudimg.io/4/3/a/b/43ab276d-558a-4210-87c6-a592142b6fd9.png?ci_eqs=&ci_seal=34276160636317df9a25568dc19855c7fb6c7968',
                        mobile: 'https://cdnihddipa.cloudimg.io/8/7/e/c/87ec661c-959d-4884-9af6-064ecd2436ae.png?ci_eqs=&ci_seal=a0d9bab2dccd077e2e1cef78c60f93105897faae',
                    },
                    items: [
                        {
                            illustration: 'give-your-opinion',
                            number: {
                                desktop: 'https://cdnihddipa.cloudimg.io/d/1/4/f/d14ffb5a-76e3-4289-9bcd-c58ce6dd6ebf.png?ci_eqs=&ci_seal=61114ed21810a053d4792169e4e13d17b4bf9852',
                                mobile: 'https://cdnihddipa.cloudimg.io/3/2/7/c/327ccbb8-bed3-4fa1-a733-e3ebffb05b83.png?ci_eqs=&ci_seal=9f57cbcad0c24fc88280a65473c8cd51a3d5b3ac',
                            },
                        },
                        {
                            illustration: 'business-checklist-document',
                            number: {
                                desktop: 'https://cdnihddipa.cloudimg.io/0/7/d/b/07db49cc-90ca-41bb-b443-1c4311e615c2.png?ci_eqs=&ci_seal=bdd3ecd69ee4a6d457b6bb5cf4f1d322a70f7265',
                                mobile: 'https://cdnihddipa.cloudimg.io/f/3/2/f/f32fe485-c497-4cb2-aaa1-bdc1c871321d.png?ci_eqs=&ci_seal=f77926ecbbfbbce78018188412b3393c82ff5da1',
                            },
                        },
                        {
                            illustration: 'business-workspace',
                            number: {
                                desktop: 'https://cdnihddipa.cloudimg.io/1/5/a/1/15a1f82f-af70-4aa2-b8df-ea5c5a9a164f.png?ci_eqs=&ci_seal=99b80d75d8593c535d9a92723b85337033501015',
                                mobile: 'https://cdnihddipa.cloudimg.io/7/8/7/9/7879b95f-c7b8-4f99-8217-baec49639f7e.png?ci_eqs=&ci_seal=b89449b76f33ed1d4f0fd3751069651b9ef2a20d',
                            },
                        },
                        {
                            illustration: 'communication-messages-marketing',
                            number: {
                                desktop: 'https://cdnihddipa.cloudimg.io/2/9/f/f/29ff74f9-bee3-4208-b85d-ca3d2a38396f.png?ci_eqs=&ci_seal=a1dc532fc61862cf7f1575b0e915b4d2983b2a9b',
                                mobile: 'https://cdnihddipa.cloudimg.io/6/d/1/7/6d178f36-32d3-4161-858c-51835bacf295.png?ci_eqs=&ci_seal=75e68f204c7e7c54472992deb6a41188a4e8c262',
                            },
                        },
                        {
                            illustration: 'finance-money-profit',
                            number: {
                                desktop: 'https://cdnihddipa.cloudimg.io/2/b/8/9/2b898ed9-b246-452e-84c2-1383a05b385a.png?ci_eqs=&ci_seal=4a2428a7db7c4573883ad17712975abfbf028e03',
                                mobile: 'https://cdnihddipa.cloudimg.io/1/f/3/1/1f31b2b3-a250-4562-8bc4-0712e84e7626.png?ci_eqs=&ci_seal=8d13a7f7bdb395754c0f92b58f8ab9f2b2eb7537',
                            },
                        },
                    ],
                },
                contact: {
                    img: {
                        desktop: 'https://cdnihddipa.cloudimg.io/1/e/6/f/1e6fdba4-ae43-4668-8fed-2c3032960173.jpg?ci_eqs=&ci_seal=b06bd0c8fcb3e27eaf2ac7b35903d7a9c6d63bf2',
                        tablet: 'https://cdnihddipa.cloudimg.io/5/8/5/d/585d1782-84f3-4e16-84d7-a485aa334b23.jpg?ci_eqs=&ci_seal=5b3b0f2e405b303cf9d69e9b69a2ae7fb2c53074',
                        mobile: 'https://cdnihddipa.cloudimg.io/c/3/f/7/c3f7e055-6c09-4b16-a032-ce78b3fcdc04.png?ci_eqs=&ci_seal=50327b43b729e89b76b6c3bdc4d487fc3accfb5f',
                    },
                    items: [
                        {
                            content: '+49 5245 8799684',
                            icon: PhoneIcon,
                        },
                    ],
                },
            },
        },
    },
});
